import type { DecoBuildCtx } from "./define.ts";
import { shade, rand } from "../color.ts";

// Lily pads floating on the water — flat lathe discs with a slightly raised lip,
// occasionally with a white bloom (rounded art style, plan 28 stage 4 — was a
// cylinder disc + a box bloom).
// Geometry only — spawn metadata (weight/mapColor/habitat/sway/…) lives in
// content/decos/lilypad.json; this build is registered in src/model/coded.ts.
const build: (ctx: DecoBuildCtx) => void = ({ lathe, ball, seed }) => {
    const count = 1 + Math.floor(rand(seed) * 3);
    for (let i = 0; i < count; i++) {
      const a = rand(seed + i * 6) * Math.PI * 2;
      const r = 0.4 + rand(seed + i * 6 + 1) * 0.6;
      const x = Math.cos(a) * r, z = Math.sin(a) * r;
      const pad = 0.35 + rand(seed + i * 6 + 2) * 0.3;
      // profile bottom→top: narrow underside → full width → a slight raised lip
      lathe(x, 0.02, z,
        [[0.2 * pad, 0], [pad, 0.02], [pad * 0.92, 0.06]],
        shade(0x3f8a4a, (rand(seed + i) - 0.5) * 0.2), undefined, 10);
      if (rand(seed + i * 6 + 3) > 0.6) {
        ball(x, 0.12, z, 0.08, 0xe8d8ec);   // small white bloom
      }
    }
  };

export default build;
